import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function Ellipsis(props) {
  const { height, width, iconColor } = props;

  return (
    <svg viewBox="0 0 17 3" width={width} height={height} version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g fillRule="nonzero" fill={iconColor}>
        <circle cx="1.5" cy="1.5" r="1.5" />
        <circle cx="8.5" cy="1.5" r="1.5" />
        <circle cx="15.5" cy="1.5" r="1.5" />
      </g>
    </svg>
  );
}

Ellipsis.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

Ellipsis.defaultProps = { height: 3, width: 17, iconColor: colors.colorBlue };

export default Ellipsis;
